const STEPS = [
  {
    num: 1,
    title: '填写基本信息',
    desc: '填写学校、教师、课程名称、学科、年级等基本信息',
    icon: 'ri-file-edit-line',
    color: '#22d3ee',
  },
  {
    num: 2,
    title: '上传课程资料',
    desc: '上传推课视频（必填）及课程讲义、课件PPT、学生作业等材料',
    icon: 'ri-upload-cloud-2-line',
    color: '#a78bfa',
  },
  {
    num: 3,
    title: '启动 AI 评价',
    desc: '点击「开始 AI 评价」，系统将自动分析课程并生成多维度评分报告',
    icon: 'ri-sparkling-line',
    color: '#34d399',
  },
];

const DIMENSIONS = [
  { label: 'A. 价值引领',    color: '#e879f9' },
  { label: 'B. 教学内容',    color: '#22d3ee' },
  { label: 'C. 教学目标',    color: '#22d3ee' },
  { label: 'D. 教学设计',    color: '#a3e635' },
  { label: 'E. 组织互动',    color: '#fb923c' },
  { label: 'F. 学生成效',    color: '#fb923c' },
];

export default function EmptyRightPanel() {
  return (
    <div className="h-full flex flex-col gap-2 overflow-hidden" style={{ padding: '4px 4px 4px' }}>
      {/* 操作指引卡 */}
      <div className="rounded-xl overflow-hidden flex flex-col" style={{
        background: 'linear-gradient(145deg, rgba(255,255,255,0.04) 0%, rgba(10,20,40,0.88) 100%)',
        border: '1px solid rgba(167,139,250,0.25)',
        backdropFilter: 'blur(16px)',
        flex: '0 0 auto',
      }}>
        <div className="flex items-center gap-2 px-4 py-2.5 flex-shrink-0" style={{ borderBottom: '1px solid rgba(167,139,250,0.12)' }}>
          <div className="w-1 h-4 rounded-full flex-shrink-0"
            style={{ background: 'linear-gradient(to bottom, #a78bfa, rgba(167,139,250,0.5))', boxShadow: '0 0 8px rgba(167,139,250,0.8)' }} />
          <span className="text-white font-bold font-semibold tracking-wide" style={{ fontSize: '24px' }}>操作指引</span>
        </div>

        <div className="px-4 py-3 flex flex-col gap-3">
          {STEPS.map((step, i) => (
            <div key={step.num} className="flex gap-3">
              {/* 步骤连接线 */}
              <div className="flex flex-col items-center flex-shrink-0" style={{ width: '28px' }}>
                <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ background: `${step.color}18`, border: `1px solid ${step.color}45` }}>
                  <span style={{ fontSize: '16px', fontWeight: 700, color: step.color }}>{step.num}</span>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="flex-1 w-px mt-1" style={{ background: `linear-gradient(to bottom, ${step.color}40, transparent)`, minHeight: '14px' }} />
                )}
              </div>
              {/* 内容 */}
              <div className="flex-1 pb-1">
                <div className="flex items-center gap-2 mb-1">
                  <i className={step.icon} style={{ fontSize: '16px', color: step.color }} />
                  <span className="font-semibold" style={{ fontSize: '17px', color: step.color }}>{step.title}</span>
                </div>
                <p style={{ fontSize: '16px', color: 'white', lineHeight: 1.6 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 评价维度预览卡 */}
      <div className="rounded-xl overflow-hidden flex flex-col flex-1 min-h-0" style={{
        background: 'linear-gradient(145deg, rgba(255,255,255,0.04) 0%, rgba(10,20,40,0.88) 100%)',
        border: '1px solid rgba(16,185,129,0.25)',
        backdropFilter: 'blur(16px)',
      }}>
        <div className="flex items-center gap-2 px-4 py-2.5 flex-shrink-0" style={{ borderBottom: '1px solid rgba(16,185,129,0.12)' }}>
          <div className="w-1 h-4 rounded-full flex-shrink-0"
            style={{ background: 'linear-gradient(to bottom, #34d399, rgba(16,185,129,0.5))', boxShadow: '0 0 8px rgba(16,185,129,0.8)' }} />
          <span className="text-white font-bold font-semibold tracking-wide" style={{ fontSize: '24px' }}>评价维度预览</span>
        </div>

        <div className="flex-1 min-h-0 px-4 py-3 flex flex-col gap-2 overflow-y-auto">
          {DIMENSIONS.map(dim => (
            <div key={dim.label} className="flex items-center gap-3 py-2 px-3 rounded-lg"
              style={{ background: `${dim.color}08`, border: `1px solid ${dim.color}20` }}>
              <div className="w-2 h-2 rounded-full flex-shrink-0"
                style={{ background: dim.color, boxShadow: `0 0 6px ${dim.color}` }} />
              <span style={{ fontSize: '17px', color: 'white', flex: 1 }}>{dim.label}</span>
              {/* 骨架分数占位 */}
              <div className="flex items-center gap-1">
                <div className="h-4 w-7 rounded" style={{ background: 'rgba(255,255,255,0.07)' }} />
                <span style={{ fontSize: '17px', color: 'white' }}>分</span>
              </div>
            </div>
          ))}

          <div className="mt-1 flex items-center justify-center gap-2 py-2.5 rounded-lg"
            style={{ background: 'rgba(34,211,238,0.05)', border: '1px dashed rgba(34,211,238,0.2)' }}>
            <i className="ri-lock-line" style={{ fontSize: '17px', color: 'rgba(34,211,238,0.4)' }} />
            <span style={{ fontSize: '16px', color: 'white' }}>评价完成后解锁详细报告</span>
          </div>
        </div>
      </div>
    </div>
  );
}
